import { Link, useParams } from "react-router-dom";
import parse from "html-react-parser";
import ArticleHeader from "./ArticleHeader";
import { useEffect } from "react";
import BackBtn from "./BackBtn";

function Article(props) {
  const articleId = useParams();
  const fetchArticles = props.data.content.articles;
  const fetchCategories = props.data.content.categories;
  let relatedArticlesIds = fetchArticles.find(
    (article) => article.id == articleId.id
  ).relatedArticles;

  useEffect(() => {
    const sidebarOpenMobile = document.querySelector(".sidebarOpenMobile");
    sidebarOpenMobile.addEventListener("click", () => {
      sidebarOpenMobile.parentNode.classList.toggle("active");
    });

    document.body.className = "search-shrink";
    return () => {
      document.body.className = "";
    };
  }, []);

  return (
    <section className="article">
      <BackBtn />
      <div className="content-split">
        <div className="sidebar">
          <button className="sidebarOpenMobile">
            <span>Articles in this section</span>
            <svg width="24" height="24" fill="none" viewBox="1 2 20 20">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M15.25 10.75L12 14.25L8.75 10.75"
              ></path>
            </svg>
          </button>

          <ul className="sidebarLinks">
            {fetchArticles
              .filter(
                (article) =>
                  article.categoryId ==
                    fetchCategories[article.categoryId].id &&
                  fetchCategories[article.categoryId].category ==
                    fetchCategories[fetchArticles[articleId.id].categoryId]
                      .category &&
                  article.subcategoryId ==
                    fetchCategories
                      .find(
                        (post) =>
                          post.category ==
                          fetchCategories[
                            fetchArticles[articleId.id].categoryId
                          ].category
                      )
                      ?.subcategories.find(
                        (post) =>
                          post.id ==
                          fetchArticles.find((post) => post.id == articleId.id)
                            .subcategoryId
                      )?.id
              )
              .map((post) => (
                <Link
                  to={`/article/${post.question
                    .replace(/[?=]/g, "")
                    .replace(/\W+/g, "-")
                    .toLowerCase()}/${post.id}`}
                  className={post.id == articleId.id ? "active" : ""}
                  key={post.id}
                >
                  {post.question}
                </Link>
              ))}
          </ul>
        </div>
        <div className="content">
          <ul className="breadcrumbs">
            <li>
              <Link to="/">{props.data.settings.site}</Link>
            </li>
            <li>
              <Link
                to={`/category/${
                  fetchCategories[fetchArticles[articleId.id].categoryId]
                    .category
                }`}
              >
                {fetchCategories[fetchArticles[articleId.id].categoryId].title}
              </Link>
            </li>

            {fetchCategories
              .find(
                (post) =>
                  post.category ==
                  fetchCategories[fetchArticles[articleId.id].categoryId]
                    .category
              )
              ?.subcategories.find(
                (post) =>
                  post.id ==
                  fetchArticles.find((post) => post.id == articleId.id)
                    .subcategoryId
              )?.title ? (
              <li>
                <Link
                  to={`/category/${
                    fetchCategories[fetchArticles[articleId.id].categoryId]
                      .category
                  }/${
                    fetchCategories
                      .find(
                        (post) =>
                          post.category ==
                          fetchCategories[
                            fetchArticles[articleId.id].categoryId
                          ].category
                      )
                      ?.subcategories.find(
                        (post) =>
                          post.id ==
                          fetchArticles.find((post) => post.id == articleId.id)
                            .subcategoryId
                      )?.category
                  }`}
                >
                  {
                    fetchCategories
                      .find(
                        (post) =>
                          post.category ==
                          fetchCategories[
                            fetchArticles[articleId.id].categoryId
                          ].category
                      )
                      ?.subcategories.find(
                        (post) =>
                          post.id ==
                          fetchArticles.find((post) => post.id == articleId.id)
                            .subcategoryId
                      )?.title
                  }
                </Link>
              </li>
            ) : (
              ""
            )}
          </ul>

          {fetchArticles
            .filter((post) => post.id == articleId.id)
            .map((post) => {
              return (
                <div key={post.id}>
                  <ArticleHeader title={post.question} updated={post.updated} />
                  <div className="htmlWrapper">{parse(post.html)}</div>
                </div>
              );
            })}

          {relatedArticlesIds.length < 1 ? (
            ""
          ) : (
            <div className="relatedArticles">
              <h2>More like this</h2>
              <ul>
                {fetchArticles
                  .filter((article) => relatedArticlesIds.includes(article.id))
                  .map((article) => (
                    <li key={article.id}>
                      <Link to={`/article/${article.url}/${article.id}`}>
                        {article.question}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Article;
